import { PayementModeType, ReceiptPaymentLabel } from "src/utils/constants/constant";
import { useEffect, useState } from "react";
import { calculateGst as calculateSGst, currencyFormat, dateFormatYMD, toWords } from "src/utils/helperFunction";
import { ReceiptLogo as TopBarLogo } from "./ReceiptLogo";
import { AuthorizedSignature } from "./AuthorizedSignature";
import { IStudentInvoice } from "src/services/feesDetails/fees.model";
import { IStudentList } from "src/services/student/student.model";

interface ExactReceiptProps {
  invoiceData: IStudentInvoice | null | undefined;
  admissionData: IStudentList | undefined;
  label: string;
}

const ExactReceiptWithGst = ({ invoiceData, admissionData, label }: ExactReceiptProps) => {
  const [receiptType, setReceiptType] = useState<string>();
  const [isChequeType, setIsChequeType] = useState<boolean>(false);
  useEffect(() => {
    if (invoiceData?.payment_mode === PayementModeType.CASH) {
      setReceiptType(ReceiptPaymentLabel.CASH);
      setIsChequeType(false);
    } else if (
      invoiceData?.payment_mode === PayementModeType.CHEQUE ||
      invoiceData?.payment_mode === PayementModeType.DD ||
      invoiceData?.payment_mode === PayementModeType.NEFT_IMPS
    ) {
      setReceiptType(ReceiptPaymentLabel.CHEQUE);
      setIsChequeType(true);
    } else {
      setIsChequeType(false);
      setReceiptType(ReceiptPaymentLabel.ONLINE);
    }
  }, [invoiceData]);

  const isPenalty = (invoiceData?.admission_penalty?.length ?? 0) > 0;

  return (
    <>
      <table className="student-receipt-table student-receipt-table-with-gst">
        <tbody
          className={"receipt-content-padding"}
        >
          <tr>
            {/* <Temporary Code Comment> */}
            {/* <ReceiptLogo invoiceDate={invoiceData?.invoiceDate} /> */}
          </tr>
          <tbody
            className={"gx-d-flex gx-justify-content-between gx-align-items-center receipt-bottom-spacing" + (invoiceData?.branch?.registered_office_address ? "" : " receipt-border-bottom-dark")}
          >
            <TopBarLogo invoiceData={invoiceData} />
            <tr className={"receipt-width-20 gx-text-center"}>
              <td
                className={"gx-d-inline-block receipt-font-heading receipt-font-bold"}
              >
                Tax Invoice
              </td>
            </tr>
            <tr className={"receipt-width-40 gx-text-right"}>
              <td
                className={"receipt-font-bold receipt-font-large receipt-branch-title-spacing"}
              >
                {invoiceData?.branch_name !== null
                  ? invoiceData?.branch_name
                  : invoiceData?.branch?.title}
              </td>
              <td>
                <b>Branch Address</b> :{" "}
                {invoiceData?.address || invoiceData?.branch?.address || "-"}
              </td>
              <td>
                Mobile No :&nbsp;
                {invoiceData?.branch?.mobile_one ||
                  invoiceData?.branch?.landline_no}
              </td>
            </tr>
          </tbody>
          {invoiceData?.branch?.registered_office_address ? (
            <tbody>
              <tr>
                <td
                  className={"receipt-border-bottom-dark receipt-address-padding receipt-wrap-text receipt-break-word"}
                >
                  <b>Registered Office Address</b> :{" "}
                  {invoiceData.branch.registered_office_address}
                </td>
              </tr>
            </tbody>
          ) : null}
          <tbody
            className={"gx-d-flex gx-justify-content-between receipt-align-baseline"}
          >
            <tr>
              <td>
                <b>Receipt No :</b>&nbsp; {invoiceData?.invoiceNo}
              </td>
              <td>
                <b>Enrollment No :&nbsp;</b>{" "}
                {invoiceData?.admission?.enrollment_number}
              </td>
              <td
                className={"gx-text-capitalize"}
              >
                <b>Student Name :&nbsp;</b>
                {invoiceData?.admission?.first_name +
                  " " +
                  invoiceData?.admission?.middle_name +
                  " " +
                  invoiceData?.admission?.last_name}
              </td>
            </tr>
            <tr>
              <td>
                <b>GR Id :&nbsp;</b> {invoiceData?.admission?.gr_id}
              </td>
              <td>
                <b>{label}&nbsp;Name</b> :&nbsp;
                {admissionData && admissionData?.package?.name
                  ? admissionData?.package?.name
                  : admissionData?.admission_subcourses
                      ?.map((admissionSubcourse) => admissionSubcourse.subcourse?.name)
                      .join(", ")}
              </td>
            </tr>
            <tr className={"gx-text-right"}>
              <td className={"gx-text-nowrap"}>
                <b>Date :&nbsp;</b>
                {dateFormatYMD(invoiceData?.pay_date, "D MMM YY")}
              </td>
              <td className={"gx-text-nowrap"}>
                <b>SAC :&nbsp;</b> 9992
              </td>
            </tr>
          </tbody>

          <td>
            <table
              className={"gx-w-100 receipt-border receipt-table-spacing"}
            >
              <tr
                className={"gx-d-flex gx-justify-content-between gx-align-items-center"}
              >
                <th
                  className={"receipt-border-right gx-text-center receipt-width-40"}
                >
                  Fees Type
                </th>
                {invoiceData?.igst ? (
                  <th
                    className={"receipt-border-right gx-text-center receipt-width-60"}
                  >
                    IGST
                  </th>
                ) : (
                  <>
                    <th
                      className={"receipt-border-right gx-text-center receipt-width-20"}
                    >
                      CGST(9%)
                    </th>
                    <th
                      className={"receipt-border-right gx-text-center receipt-width-20"}
                    >
                      SGST(9%)
                    </th>
                    <th
                      className={"receipt-border-right gx-text-center receipt-width-20"}
                    >
                      Tax Amount
                    </th>
                  </>
                )}
                <th
                  className={"gx-text-center receipt-width-20"}
                >
                  Total Amount (₹)
                </th>
              </tr>
              <>
                {invoiceData?.invoice_fees &&
                  invoiceData?.invoice_fees?.map((invoiceFee) => (
                    <>
                      <tr
                        className={"gx-d-flex receipt-border-top"}
                      >
                        <td className={"receipt-width-40 gx-p-0"}>
                          <tr
                            className={"gx-d-flex gx-w-100 gx-justify-content-around"}
                          >
                            <td

                              className={"gx-text-center gx-w-50 receipt-border-right"}
                            >
                              {invoiceFee.fee_type?.name}
                            </td>
                            <td

                              className={"gx-text-center gx-w-50 receipt-border-right"}
                            >
                              <span>&#8377;</span>
                              {currencyFormat(
                                Math.trunc(
                                  Number(invoiceFee.amount) -
                                    calculateSGst(invoiceFee.amount ?? 0) * 2,
                                ),
                              )}
                            </td>
                          </tr>
                        </td>
                        {invoiceData?.igst ? (
                          <td
                            className={"gx-text-center receipt-width-60 receipt-border-right"}
                          >
                            <span>&#8377;</span>
                            {currencyFormat(calculateSGst(invoiceFee.amount ?? 0) * 2)}
                          </td>
                        ) : (
                          <>
                            <td
                              className={"gx-text-center receipt-width-20 receipt-border-right"}
                            >
                              <span>&#8377;</span>
                              {currencyFormat(calculateSGst(invoiceFee.amount ?? 0))}
                            </td>
                            <td
                              className={"gx-text-center receipt-width-20 receipt-border-right"}
                            >
                              <span>&#8377;</span>
                              {currencyFormat(calculateSGst(invoiceFee.amount ?? 0))}
                            </td>
                            <td
                              className={"gx-text-center receipt-width-20 receipt-border-right"}
                            >
                              <span>&#8377;</span>
                              {currencyFormat(calculateSGst(invoiceFee.amount ?? 0) * 2)}
                            </td>
                          </>
                        )}
                        <td
                          className={"gx-text-center receipt-width-20"}
                        >
                          <span>&#8377;</span>
                          {currencyFormat(Math.trunc(Number(invoiceFee.amount)))}
                        </td>
                      </tr>
                    </>
                  ))}
                {invoiceData && isPenalty && (
                  <>
                    <tr
                      className={"gx-d-flex receipt-border-top"}
                    >
                      <td className={"receipt-width-40 gx-p-0"}>
                        <tr
                          className={"gx-d-flex gx-w-100 gx-justify-content-around"}
                        >
                          <td

                            className={"gx-text-center gx-w-50 receipt-border-right"}
                          >
                            {invoiceData?.admission_penalty?.[0]?.incomeType
                              ?.name ?? ""}
                          </td>
                          <td

                            className={"gx-text-center gx-w-50 receipt-border-right"}
                          >
                            <span>&#8377;</span>
                            {currencyFormat(
                              Math.trunc(
                                Number(invoiceData?.payAmount) -
                                  calculateSGst(invoiceData.payAmount) * 2,
                              ),
                            )}
                          </td>
                        </tr>
                      </td>
                      {invoiceData?.igst ? (
                        <td
                          className={"gx-text-center receipt-width-60 receipt-border-right"}
                        >
                          <span>&#8377;</span>
                          {currencyFormat(
                            calculateSGst(invoiceData.payAmount) * 2,
                          )}
                        </td>
                      ) : (
                        <>
                          <td
                            className={"gx-text-center receipt-width-20 receipt-border-right"}
                          >
                            <span>&#8377;</span>
                            {currencyFormat(
                              calculateSGst(invoiceData.payAmount),
                            )}
                          </td>
                          <td
                            className={"gx-text-center receipt-width-20 receipt-border-right"}
                          >
                            <span>&#8377;</span>
                            {currencyFormat(
                              calculateSGst(invoiceData.payAmount),
                            )}
                          </td>
                          <td
                            className={"gx-text-center receipt-width-20 receipt-border-right"}
                          >
                            <span>&#8377;</span>
                            {currencyFormat(
                              calculateSGst(invoiceData.payAmount) * 2,
                            )}
                          </td>
                        </>
                      )}
                      <td
                        className={"gx-text-center receipt-width-20"}
                      >
                        <span>&#8377;</span>
                        {currencyFormat(
                          Math.trunc(Number(invoiceData?.payAmount)),
                        )}
                      </td>
                    </tr>
                  </>
                )}
              </>
              <tr
                className={"gx-d-flex receipt-border-top"}
              >
                <td className={"receipt-width-40 gx-p-0"}>
                  <tr
                    className={"gx-d-flex gx-w-100 gx-justify-content-around"}
                  >
                    <th

                      className={"gx-text-center gx-w-50 receipt-border-right"}
                    >
                      Total
                    </th>
                    <th

                      className={"gx-text-center gx-w-50 receipt-border-right"}
                    >
                      <span>&#8377;</span>
                      {invoiceData?.payAmount &&
                        currencyFormat(
                          Number(invoiceData?.payAmount) -
                            calculateSGst(invoiceData?.payAmount) * 2,
                        )}
                    </th>
                  </tr>
                </td>
                {invoiceData?.igst ? (
                  <td
                    className={"gx-text-center receipt-width-60 receipt-border-right"}
                  >
                    <span>&#8377;</span>
                    {currencyFormat(calculateSGst(invoiceData?.payAmount) * 2)}
                  </td>
                ) : (
                  <>
                    <td
                      className={"gx-text-center receipt-width-20 receipt-border-right"}
                    >
                      <span>&#8377;</span>
                      {currencyFormat(calculateSGst(invoiceData?.payAmount))}
                    </td>
                    <td
                      className={"gx-text-center receipt-width-20 receipt-border-right"}
                    >
                      <span>&#8377;</span>
                      {currencyFormat(calculateSGst(invoiceData?.payAmount))}
                    </td>
                    <td
                      className={"gx-text-center receipt-width-20 receipt-border-right"}
                    >
                      <span>&#8377;</span>
                      {currencyFormat(
                        calculateSGst(invoiceData?.payAmount) * 2,
                      )}
                    </td>
                  </>
                )}
                <th
                  className={"gx-text-center receipt-width-20"}
                >
                  <span>&#8377;</span>
                  {currencyFormat(Number(invoiceData?.payAmount))}
                </th>
              </tr>
            </table>
          </td>
          <tbody>
            <tr
              className={"gx-d-flex gx-justify-content-between receipt-auto-height receipt-bottom-spacing"}
            >
              <tr>
                {isChequeType === true ? (
                  <tr className={"receipt-flex-one"}>
                    <td>
                      <b>Payment Mode :&nbsp;</b> {receiptType}&nbsp;Payment
                    </td>
                    <td>
                      <b>Cheque Holder Name :&nbsp;</b>{" "}
                      {invoiceData?.cheque_holder_name}&nbsp;
                      <br />
                      <b>Cheque No</b> :&nbsp;
                      {invoiceData?.cheque_no},&nbsp;
                      <b>Cheque Date</b>
                      :&nbsp;
                      {dateFormatYMD(invoiceData?.cheque_date, "DD-MM-YYYY")}
                      <br />
                      <b>Bank Name</b> :&nbsp;
                      {invoiceData?.bank_name}, ({invoiceData?.bank_branch_name}
                      )
                    </td>
                  </tr>
                ) : (
                  <tbody>
                    <tr>
                      <td className={"receipt-flex-one"}>
                        <b>Payment Mode :&nbsp;</b> {receiptType} Payment
                      </td>
                    </tr>

                    {invoiceData?.payment_mode === PayementModeType.ONLINE_PAYMENT && (
                      <>
                        {invoiceData?.transaction_no && (
                          <tr>
                            <td>
                              <b>Transaction ID :&nbsp;</b>{" "}
                              {invoiceData.transaction_no}
                            </td>
                          </tr>
                        )}
                        {invoiceData?.transaction_date && (
                          <tr>
                            <td>
                              <b>Transaction Date :&nbsp;</b>{" "}
                              {dateFormatYMD(invoiceData.transaction_date, "DD-MM-YYYY")}
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                )}
                {invoiceData?.gst_no && (
                  <td
                    className={"gx-text-capitalize"}
                  >
                    <b>GSTIN</b> : {invoiceData?.gst_no}
                  </td>
                )}
              </tr>
              <tr>
                <td
                  className={"gx-text-capitalize"}
                >
                  <b>The Sum of :&nbsp;</b>
                  {invoiceData?.invoice_fees &&
                    toWords.convert(
                      Number(
                        Number(
                          invoiceData?.invoice_fees
                            ?.map((invoiceFee) => invoiceFee.amount)
                            ?.reduce((total, amount) => {
                              return Number(total) + Number(amount);
                            }, 0),
                        ),
                      ),
                    )}
                </td>
              </tr>
            </tr>
            <tr
              className={"gx-d-flex gx-justify-content-end gx-align-items-end receipt-signature-spacing"}
            >
              <tr className={"gx-ml-auto"}>
                <td>
                  <AuthorizedSignature />
                </td>
                <td
                  className={"receipt-line-compact gx-font-weight-medium gx-text-right"}
                >
                  ----------------------------
                </td>
                <td
                  className={"gx-font-weight-medium gx-text-center"}
                >
                  Authorized By
                </td>
              </tr>
            </tr>
            <td
              className={"receipt-note-spacing receipt-font-small receipt-line-readable receipt-word-spacing"}
            >
              <div>
                <b>T&amp;C:</b>{" "}This invoice generated for educational.
              </div>
              <div>
                Invoice issued under section 31 read with rule 46 of CGST Act 2017.
              </div>
              <div>*Fees will be not returnable.</div>
              <div>
                <b>Note:</b>&nbsp;This&nbsp;is&nbsp;a&nbsp;digitally&nbsp;generated&nbsp;receipt.
              </div>
              {invoiceData?.remarks ? (
                <p>
                  <b>Remarks&nbsp;</b>:&nbsp;{" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: invoiceData?.remarks,
                    }}
                  />
                  {}
                </p>
              ) : (
                ""
              )}
            </td>
          </tbody>
        </tbody>
      </table>
    </>
  );
};

export default ExactReceiptWithGst;
